/*
 *
 * Helper to categorized an error as a Nuxt instance error
 * This type of errors occurs when Nuxt context is lost
 * Nuxt context can be lost :
 * - when a composable is used outside of a plugin, Nuxt hook, Nuxt middleware, or Vue setup function.
 * - sometimes when async context is need (i.e. with try/catch statements containing await,
 *   see: https://nuxt.com/docs/4.x/api/composables/use-nuxt-app#remaining-issues
 *
 * This error could be fix with https://nuxt.com/docs/4.x/api/composables/use-nuxt-app#runwithcontext
 *
 * */

export function isNuxtInstanceError(errorMessage: string) {
    const NUXT_INSTANCE_ERROR_MESSAGE = '[nuxt] instance unavailable';
    const NUXT_INSTANCE_COMPOSABLE_ERROR_MESSAGE = '[nuxt] A composable that requires access to the Nuxt instance ';
    const isNuxtInstanceError = [NUXT_INSTANCE_ERROR_MESSAGE, NUXT_INSTANCE_COMPOSABLE_ERROR_MESSAGE].some((message) =>
        errorMessage.includes(message),
    );

    return isNuxtInstanceError;
}
